import { pickBy } from 'lodash';

export type Environments = {
  production?: boolean;
  demo?: boolean;
  staging?: boolean;
  qa?: boolean;
  development?: boolean;
};

export type Environment = string | undefined;

export const getEnv = (env: Environment = process.env.STAGE): Environments => ({
  production: env === 'production',
  demo: env?.includes('demo'),
  staging: env === 'staging',
  qa: env?.includes('qa'),
  development: env === 'development',
});

export const getEnvString = (env: Environment) => {
  const currentEnv = env ? getEnv(env) : getEnv(process.env.STAGE);

  return Object.keys(pickBy(currentEnv)).join();
};
